import type { ReactNode, JSX} from "react";
import { cn } from "./cn";

export interface InfoCardRow {
  readonly label: string;
  readonly value: ReactNode;
  readonly action?: ReactNode;
}

export interface InfoCardProps {
  readonly rows: readonly InfoCardRow[];
}

/**
 * Card displaying key-value rows with optional actions (copy buttons, etc.).
 * Used in contacts info, company info, etc.
 */
export function InfoCard({ rows }: InfoCardProps): JSX.Element {
  return (
    <div className="flex flex-col bg-surface-secondary rounded-lg py-1.5 border border-edge">
      {rows.map((row, index) => (
        <div
          key={row.label}
          className={cn(
            "flex items-center justify-between px-3.5 py-2",
            index < rows.length - 1 && "border-b border-edge",
          )}
        >
          <div>
            <div className="text-[11px] text-content-tertiary lowercase">{row.label}</div>
            <div className="text-sm text-content">{row.value}</div>
          </div>
          {row.action}
        </div>
      ))}
    </div>
  );
}
